import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/loader/report/styles.scss';export default {
  "report": "_report_1bzap_1",
  "headerItem": "_headerItem_1bzap_9",
  "submissionDateSkeleton": "_submissionDateSkeleton_1bzap_24",
  "authorHeader": "_authorHeader_1bzap_31",
  "authorSkeleton": "_authorSkeleton_1bzap_38",
  "nameSkeleton": "_nameSkeleton_1bzap_44",
  "indicators": "_indicators_1bzap_49"
};